<template>

  <p>PREPARE YEAH</p>

  <!-- <Delivery></Delivery> -->

  <!-- <PromoCode></PromoCode> -->

  <!-- <Totals :has-items="false" :is-quote="false"></Totals> -->

</template>

<script setup>
import { ref, onMounted } from 'vue'

var _ = require('lodash');
import axios from 'axios';

const props = defineProps([
])

const enablePromoCode = ref(false);
const promoCodeInput = ref('');
const promoCodeResponse = ref('');

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

import { useLightboxStore } from "@/stores/lightbox";
const lightbox = useLightboxStore();

import Totals from "@/components/builder/quote/Totals.vue";
import Delivery from "@/components/builder/quote/Delivery.vue";
import PromoCode from "@/components/builder/quote/PromoCode.vue";

</script>
